// extracted by mini-css-extract-plugin
export default {"section":"sv-z","inSectionButton":"tv-z","addressCard":"uv-z","disabled":"vv-z","cautionBox":"wv-z","failureBox":"xv-z","fade-out":"yv-z","successBox":"zv-z"};